import { PayloadAction } from '@reduxjs/toolkit'
import { Draft } from 'immer'
import { PinterestAiContentMode, PinterestBoard } from 'shared/types'
import ComposerState from '../state'

export const pinterestReducers = {
  selectPinterestBoard: (state: Draft<ComposerState>, action: PayloadAction<{ ppid: string, board: PinterestBoard }>) => {
    const { ppid, board } = action.payload
    let profileBoards = state.pinterestBoards[ppid] || [action.payload.board]
    profileBoards = profileBoards.map(b => ({ ...b, selected: b.id === board.id }))

    state.pinterestBoards[ppid] = profileBoards
  },
  clearPinterestBoards: (state: Draft<ComposerState>) => {
    state.pinterestBoards = {}
  },
  setPinterestProfileBoards: (
    state: Draft<ComposerState>,
    action: PayloadAction<{ ppid: string, boards: Record<string, { id: string, name: string }> }>
  ) => {
    const { ppid, boards } = action.payload
    const boardsArray = Object.values(boards)
    const prevProfileBoards = state.pinterestBoards[ppid]
    const nextProfileBoards = prevProfileBoards
      ? boardsArray.map(b => ({ ...b, selected: prevProfileBoards.find(board => board.selected && board.id === b.id) !== undefined }))
      : boardsArray

    state.pinterestBoards[ppid] = nextProfileBoards
  },
  setPinTitle: (state: Draft<ComposerState>, action: PayloadAction<{ title: string, auto: boolean }>) => {
    const { title, auto } = action.payload
    const pin = state.posts.pinterest
    pin.title = title
    pin.status.touched = !auto
  },
  setPinDescription: (state: Draft<ComposerState>, action: PayloadAction<{ description: string, auto: boolean }>) => {
    const { description, auto } = action.payload
    const pin = state.posts.pinterest
    pin.description = description
    pin.status.touched = !auto
  },
  setPinDestinationUrl: (state: Draft<ComposerState>, action: PayloadAction<string>) => {
    state.posts.pinterest.destinationUrl = action.payload
  },
  setPinAiContentMode: (state: Draft<ComposerState>, action: PayloadAction<PinterestAiContentMode | undefined>) => {
    state.posts.pinterest.aiContentMode = action.payload
  }
}
